import { Button, Form, Input, Switch, Table, Tooltip } from "antd";
import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setScreenHeader } from "shared/redux/common-reducer";
import { FaSearch } from "react-icons/fa";
import { debounce } from "lodash";
import OIButton from "shared/ComponentsOI/OIButton/OIButton";
import blackRefereshIcon from "../../assets/images/blackReferesh.svg";
import { RootState } from "shared/redux/store";
import { useHistory } from "react-router-dom";
import { ColumnsType } from "antd/es/table";
import { ReactComponent as IconEditBorder } from "../../assets/images/edit_border.svg";
import { setAggregatorPageNo, setAggregatorPageSize, setAggregatorSearchParam } from "../../shared/redux/aggregator-reducer";
import API_SERVICE from "shared/services/api-service";
import { hasUserRole } from "shared/services/Utility";
import AppLoading from "shared/components/AppLoading/AppLoading";

const Aggregator: React.FC = () => {
    const dispatch = useDispatch()
    const [aggregatorForm] = Form.useForm()
    const { appColors }: any = useSelector((state: RootState) => state.common);
    const aggregator: any = useSelector((state: RootState) => state.aggregator);
    const history = useHistory();
    const [aggregatorData, setAggregatorData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const userRolePermission = hasUserRole();

    useEffect(() => {
        dispatch(setScreenHeader({ screenTitle: "Aggregator Configuration" }));
        getAggregators(aggregator.pageNo, aggregator.pageSize, aggregator.searchParam)
    }, [
        aggregator.pageNo,
        aggregator.pageSize,
        aggregator.searchParam
    ])

    const getAggregators = (
        pageNo: number = 1,
        pageSize: any = 10,
        searchParam: any = null
    ) => {
        const params = {
            pageNo: pageNo,
            pageSize: pageSize,
            searchParam: searchParam,
        };
        setLoading(true);
        API_SERVICE.getAggregators(params)
            .then((data) => {
                setAggregatorData(data?.data?.payload?.content ?? []);
                setTotalCount(data?.data?.payload?.totalElements);
            })
            .catch((e: any) => {
                API_SERVICE.handleErrors(e);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const switchChange = (record: any) => {
        const status = record.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";
        API_SERVICE.updateAggregatorStatus(record.id, status)
            .then((data) => {
                getAggregators(
                    aggregator.pageNo,
                    aggregator.pageSize,
                    aggregator.searchParam
                );
            })
            .catch((e: any) => {
                API_SERVICE.handleErrors(e);
            });
    };

    const aggregatorColumns: ColumnsType<any> = [
        {
            title: "Product",
            dataIndex: "loanProductName",
            key: "loanProductName",
            width: "100px"
        },
        {
            title: "Aggregator Name",
            dataIndex: "name",
            key: "name",
            width: "100px"
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            align: "center",
            width: "130px",
            render: (_: any, record: any) => (
                <Switch
                    checked={record.status === "ACTIVE"}
                    onClick={() => switchChange(record)}
                />
            ),
        },
        {
            title: "Action",
            dataIndex: "action",
            key: "action",
            align: "center",
            fixed: "right",
            width: "100px",
            render: (_: any, record: any) => (
                <>
                    <div className="action-button">
                        <Button
                            className="custome-btn-icon-secondary"
                            style={{ '--bgColor': appColors?.appSecondaryColor ?? "" } as any}
                            size="small"
                            type="text"
                            icon={<IconEditBorder />}
                            onClick={() => goToAggregator("edit", record)}
                            hidden={
                                !(
                                    userRolePermission["Admin"]
                                )
                            }
                        />
                    </div>
                </>
            ),
        }
    ]

    const goToAggregator = (type: string, record: any) => {
        if (type === "add") {
            history.push({ pathname: "aggregator-config/aggregator", state: { editAggregatorData: aggregatorData, screenType: "add" } });
        }
        else {
            history.push({ pathname: "aggregator-config/aggregator", state: { editAggregatorData: record, screenType: "edit" } });
        }
    }

    const refreshAggregator = () => {
        aggregatorForm.setFieldsValue({ searchBox: "" });
        dispatch(setAggregatorSearchParam(""));
        dispatch(setAggregatorPageNo(1));
    };

    const handlePaginationChange = (current: any, pageSize: any) => {
        dispatch(setAggregatorPageNo(current));
        dispatch(setAggregatorPageSize(pageSize));
        getAggregators(current, pageSize, aggregator.searchParam);
    };


    return (
        <>
            <div className="content-box">
                <Form form={aggregatorForm} className="app-filter-bar">
                    <div className="app-filter-bar-left">
                        <Form.Item
                            name="searchBox"
                            style={{ flex: 1, marginBottom: "0px" }}
                        >
                            <Input
                                size="large"
                                className="search-box"
                                placeholder="Search"
                                onChange={debounce((event) => {
                                    if (event?.target?.value?.length > 2) {
                                        dispatch(setAggregatorSearchParam(event.target.value));
                                        dispatch(setAggregatorPageNo(1));
                                    } else if (event?.target?.value?.length == 0) {
                                        dispatch(setAggregatorSearchParam(""));
                                        dispatch(setAggregatorPageNo(1));
                                    }
                                }, 600)}
                                allowClear
                                prefix={<FaSearch />}
                            />
                        </Form.Item>
                        <Tooltip title="Refresh">
                            <Button
                                type="primary"
                                className="filter-btn"
                                onClick={() => refreshAggregator()}
                            >
                                <img src={blackRefereshIcon} alt="" />
                            </Button>
                        </Tooltip>
                    </div>
                    <div className="app-filter-bar-right">
                        <OIButton
                            type="primary"
                            label="Add Aggregator"
                            className="w-170 h-center"
                            style={{ "--custColor": appColors?.appPrimaryColor } as any}
                            onClick={() => goToAggregator("add", aggregatorData)}
                        />
                    </div>
                </Form>
                <div>
                    <Table
                        columns={aggregatorColumns}
                        dataSource={aggregatorData}
                        onChange={(pagination: any) => {
                            handlePaginationChange(pagination.current, pagination.pageSize);
                        }}
                        pagination={{
                            position: ["bottomCenter"],
                            current: aggregator.pageNo,
                            pageSize: aggregator.pageSize,
                            total: totalCount,
                        }} />
                </div>
            </div>
            {loading && <AppLoading />}

        </>
    )
}

export default Aggregator
